import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bar",
  "use": "icon-bar-usage",
  "viewBox": "0 0 2 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 2 12\" id=\"icon-bar\"><g style=\"mix-blend-mode:passthrough\"><rect x=\"0\" y=\"0\" width=\"2\" height=\"12\" rx=\"0\" fill=\"#313843\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol